import Colorset from './Colorset'

export default class StockItem {
  constructor (statusid, mindex, imgsrc, colorset, sid = null, uid = null) {
    this._data = {
      sid,
      uid,
      uname: '',
      statusid,
      mindex,
      imgsrc,
      isPrivateSource: true,
      isOwnSource: false,
      colorset,
      tags: []
    }
  }

  get sid () { return `${this.uid}:${this.statusid}:${this.mindex}` }
  get statusid () { return this._data.statusid }
  get uid () { return this._data.uid }
  get uname () { return this._data.uname }
  get created () { return this._data.created ? new Date(this._data.created) : null }
  get mindex () { return this._data.mindex }
  get imgsrc () { return this._data.imgsrc }
  get isPrivateSource () { return this._data.isPrivateSource }
  get isOwnSource () { return this._data.isOwnSource }
  get colorset () {
    if (this._data.colorset) {
      const cs = new Colorset()
      cs.fromObj(this._data.colorset)
      return cs
    } else {
      return null
    }
  }
  set sid (v) { throw new Error('sid has only getter') }
  set statusid (v) { this._data.statusid = v }
  set uid (v) { this._data.uid = v }
  set uname (v) { this._data.uname = v }
  set created (v) { this._data.created = ((v && v.getTime) ? v.getTime() : v) }
  set mindex (v) { this._data.mindex = v }
  set imgsrc (v) { this._data.imgsrc = v }
  set isPrivateSource (v) { this._data.isPrivateSource = v }
  set isOwnSource (v) { this._data.isOwnSource = v }
  set colorset (v) {
    if (v && v.constructor === Colorset) {
      const data = v.clone().toObj()
      this._data.colorset = data
    } else {
      this._data.colorset = v
    }
  }
  fromObj (o) {
    Object.keys(o).forEach(k => {
      if (k !== 'sid') {
        this[k] = o[k]
      }
    })
  }

  toObj () {
    const o = JSON.parse(JSON.stringify(this._data))
    o.sid = this.sid
    return o
  }

  clone () {
    const cp = new StockItem()
    cp.fromObj(this.toObj())
    return cp
  }
}



// WEBPACK FOOTER //
// ./src/models/StockItem.js